'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getObservations = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getObservations = exports.getObservations = function getObservations(sdmxJson) {
  return R.pipe(R.pathOr({}, ['data', 'dataSets', 0, 'observations']), R.mapObjIndexed(function (observation, observationKey) {
    var value = R.head(observation);
    var attrValuesIndexes = R.tail(observation);
    var dimValuesIndexes = R.split(':', observationKey);

    return {
      key: observationKey,
      value: value,
      attrValuesIndexes: attrValuesIndexes,
      dimValuesIndexes: dimValuesIndexes
    };
  }))(sdmxJson);
};